/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_2_NameInputs */

const en_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-Hallucination`)
};

const de_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-Halluzination`)
};

const fr_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-hallucination`)
};

const es_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-alucinación`)
};

const it_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-allucinazione`)
};

const nl_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-hallucinatie`)
};

const pl_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anty-halucynacja`)
};

const fi_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallusinaatiosuoja`)
};

const da_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-hallucination`)
};

const sv_landing_testimonial_2_name = /** @type {(inputs: Landing_Testimonial_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-hallucination`)
};

/**
* | output |
* | --- |
* | "Anti-Hallucination" |
*
* @param {Landing_Testimonial_2_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_2_name = /** @type {((inputs?: Landing_Testimonial_2_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_2_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_2_name(inputs)
	if (locale === "fr") return fr_landing_testimonial_2_name(inputs)
	if (locale === "es") return es_landing_testimonial_2_name(inputs)
	if (locale === "it") return it_landing_testimonial_2_name(inputs)
	if (locale === "nl") return nl_landing_testimonial_2_name(inputs)
	if (locale === "pl") return pl_landing_testimonial_2_name(inputs)
	if (locale === "fi") return fi_landing_testimonial_2_name(inputs)
	if (locale === "da") return da_landing_testimonial_2_name(inputs)
	if (locale === "sv") return sv_landing_testimonial_2_name(inputs)
	return en_landing_testimonial_2_name(inputs)
});